<template>
  <div>
    <div class="modal modal--welcomeback modal--zero-balance " id="resubscribe_with_pin" style="display: block;">
      <div class="modal__content">
        <button class="btn modal-close"><i class="icon-close" @click="$emit('close')"></i></button>
        <div class="modal__header">
        </div>
        <div class="modal__body">
          <h1>{{ getTranslations.home_modals_resubscribepin_you_are_close }}</h1>
          <img class="modal_icon_main" src="static/images/re_subscribe.png" alt="">
          <p>{{ getTranslations.home_modals_resubscribepin_we_sent }}</p>
          <form action="" id="resubViaPin">
            <div class="form-group" :class="[ !hasErrors ? '' : 'has-warning' ]">
              <input type="text" class="form-group__textfield phone_input" :placeholder="getTranslations.home_modals_resubscribepin_enter_the" @keyup="check" v-model="pin"/>
              <span v-show="message && pin && hasErrors" class="form-group__feedback">{{ message }}</span>
            </div>
            <input type="submit" :value="getTranslations.home_modals_resubscribepin_confirm" id="resubButton" class="ti_btn--main" :class="[ !hasErrors && termsParameter ? '' : 'deactivated' ]" @click.prevent="sendPin">
          </form>
          <div v-if="checkBoxEnabled">
            <div class="form-group for_selected_op form-group--checkbox center">
              <input id="check" type="checkbox" value="terms_checked" v-model="termsParameter">
              <label v-if="!getTranslations.visitor_sign_up_3_terms_and_conditions && getTranslationByOperator(operatorIndex, 'visitor_sign_up_2_check_box_terms')" for="check">{{ getTranslationByOperator(operatorIndex, 'visitor_sign_up_2_check_box_terms') }}</label>
              <label v-else-if="!getTranslations.visitor_sign_up_3_terms_and_conditions && !getTranslationByOperator(operatorIndex, 'visitor_sign_up_2_check_box_terms')" for="check">{{ getTranslationByOperatorIfExists(operatorIndex, 'visitor_sign_up_2_check_first_text') }} <a>
                <a :href="getTranslationByOperatorIfExists(operatorIndex, 'visitor_sign_up_2_check_first_link_url')" target="_blank">{{ getTranslationByOperatorIfExists(operatorIndex, 'visitor_sign_up_2_check_first_link_text') }}</a>
              </a>{{ getTranslationByOperatorIfExists(operatorIndex, 'visitor_sign_up_2_check_second_text') }} <br><a>
                <a :href="getTranslationByOperatorIfExists(operatorIndex, 'visitor_sign_up_2_check_second_link_url')" target="_blank">{{ getTranslationByOperatorIfExists(operatorIndex, 'visitor_sign_up_2_check_second_link_text') }}</a>
              </a>{{ getTranslationByOperatorIfExists(operatorIndex, 'visitor_sign_up_2_check_third_text') }} <br><a>
                <a :href="getTranslationByOperatorIfExists(operatorIndex, 'visitor_sign_up_2_check_third_link_url')" target="_blank">{{ getTranslationByOperatorIfExists(operatorIndex, 'visitor_sign_up_2_check_third_link_text') }}</a>
              </a>
                <br>
                {{ getTranslationByOperatorIfExists(operatorIndex, 'visitor_sign_up_2_check_fourth_text') }}
              </label>
<!--              <label v-else for="check">{{ getTranslations.visitor_sign_up_3_info_msg_agree_to_terms }} <br><a>-->
<!--                <a :href="getTranslationByOperator(operatorIndex, 'project_config_visitor_register_3_terms_and_conditions')" target="_blank">{{ getTranslations.visitor_sign_up_3_terms_and_conditions }}</a>-->
<!--              </a></label>-->
            </div>
          </div>
          <span class="terms">{{ getTranslations.home_modals_resubscribepin_by_clicking_resubscribe }}<br>
            <span class="make_it_bold"><a :href="getTranslationByOperator(multiOperatorInfo.multiOperatorOrdinal, 'project_config_visitor_register_3_terms_and_conditions')">
              {{ getTranslations.home_modals_resubscribepin_terms_and_conditions }}</a>
            </span>{{ getTranslations.home_modals_resubscribepin_of_service }} </span>
        </div>
      </div>
    </div>
    <div class="overlay"></div>
  </div>
</template>

<script>
  /* eslint no-console: "off", no-param-reassign: ["error", { "props": false }], no-use-before-define: ["error", { "variables": false }] */
import { mapGetters, mapActions, mapMutations, mapState } from 'vuex';
import loading from '@/components/home/modals/Loading';
import IntegrationMixin from '@/common/mixins/integration';
import modals from '../../../common/modals';
import WelcomeReturningUnsub from './WelcomeReturningUnsub';

export default {
  // modal_resubscribe_pin.html
  name: 'resubscribe-via-pin',
  mixins: [IntegrationMixin],
  data() {
    return {
      termsParameter: false,
      nextPage: '',
      pin: '',
      message: '',
      hasErrors: false,
      ti: '',
    };
  },
  components: {
    WelcomeReturningUnsub, loading,
  },
  created() {
    if (!this.checkBoxEnabled) this.termsParameter = true;
    this.storeOperatorIndex(this.multiOperatorInfo.multiOperatorOrdinal);
  },
  mounted() {
    /* eslint-disable */
    if (this.userDetails.operatorName === 'ZAIN_KSA' && this.integrationHeader === this.availableIntegrations.KSA_MOBILY.name) {
      const ids = {
        form: 'resubViaPin',
        confirm_button: 'resubButton',
        cancel_button: 'notUsed' // not used please remove it before the commit
      };
      const partner = 'partner:4d823a08bf827d3503647cf167ff48506eeeaa72';
      const service = 'campaign:6c1874a26d0a39b7f3a0cdedc482e4b7690f3b3f';

      const detector = new Detector(ids, partner, service);
      console.log(detector);
      detector.setup();
      const form = document.getElementById(ids['form']);
      console.log('form' + form);
      form.addEventListener("submit", (e) => {
        e.preventDefault();
        function fraudDetectorLoaded() {
          const loaded = document.getElementById('fraudDetectorIsLoaded');
          console.log('loaded '+loaded);
          console.log('loaded.value '+loaded.value);
          if (loaded && loaded.value === 'yes') {
            form.submit();
          } else if ('requestIdleCallback' in window) {
            console.log('case1');
            requestIdleCallback(fraudDetectorLoaded);
          } else {
            console.log('case2');
            setTimeout(fraudDetectorLoaded, 100);
          }
        }
        fraudDetectorLoaded();
      });
    }
    /* eslint-enable */
  },
  methods: {
    ...mapActions('profile', [
      'sendReOptinPin',
      'getUserLoginDetails',
    ]),
    ...mapMutations('common', [
      'storeModalForSettings',
      'storeModalForStore',
      'storeModalForHomePage',
      'storeOperatorIndex',
    ]),
    check() {
      const validPinRegex = /^[0-9]{0,8}$/;
      const validPin = this.pin.match(validPinRegex);
      if (!validPin) {
        this.message = this.getTranslations.home_modals_resubscribepin_oops;
        this.hasErrors = true;
      } else {
        this.hasErrors = false;
        this.message = '';
      }
    },
    hasAsync() {
      const activeIntegration = this.getIntegrationByName();
      return activeIntegration && activeIntegration.value.hasAsync;
    },
    sendPin() {
      // eslint-disable-next-line
      console.log('Send Pin Method');
      const tokenElement = document.querySelector('input[name="token"]');
      if (tokenElement !== null) {
        this.ti = tokenElement.value;
        console.log('token from script: ' + this.ti);
      }
      this.message = '';
      if (this.pin.length >= 4 && this.pin.length <= 8 && !this.hasErrors) {
        // eslint-disable-next-line
        console.log('Send Pin for Resubscribe user Call in 2 step');
        const pinParam = {
          pin: this.pin,
          ti: this.ti,
        };
        this.sendReOptinPin({ pinObject: pinParam }).then(() => {
          // eslint-disable-next-line
          console.log('Resubscribe user Call in 2 step Reoptin');
          if (this.twoStepVerificationVerified) {
            this.hasErrors = false;
            if (this.hasAsync()) {
              this.showAsyncModal(loading);
              this.hasErrors = false;
              this.$axios.get(`api/getStatusVerificationPin?msisdn=${this.userDetails.msisdn}`).then((response) => {
                const resp = response.data.responseEnum;
                if (resp === 'OPERATION_SUCCESS') {
                  this.showNextModal();
                } else {
                  this.showAsyncModal(null);
                }
              });
            } else {
              this.hasErrors = false;
              this.showNextModal();
            }
          } else if (this.twoStepVerificationWrongPin) {
            this.hasErrors = true;
            this.message = this.getTranslations.home_modals_resubscribepin_oops;
          } else if (this.twoStepVerificationServerError) {
            if (sessionStorage.getItem('toPage') === '/home/settings') {
              this.storeModalForSettings(null);
              modals.hideModal(this);
            } else {
              modals.hideModalForHomeStorePage(this);
            }
          }
        });
      } else {
        this.message = this.getTranslations.home_modals_resubscribepin_oops;
        this.hasErrors = true;
      }
    },
    showAsyncModal(modal) {
      if (sessionStorage.getItem('toPage') === '/home' || sessionStorage.getItem('toPage') === '/home/profile') {
        this.storeModalForHomePage(modal);
      } else if (sessionStorage.getItem('homeCurrentTabPath') === '/home/store') {
        this.storeModalForStore(modal);
      } else {
        this.storeModalForSettings(modal);
      }
    },
    showNextModal() {
      this.getUserLoginDetails().then(() => {
        if (sessionStorage.getItem('toPage') === '/home' || sessionStorage.getItem('toPage') === '/home/profile') {
          this.storeModalForHomePage(WelcomeReturningUnsub);
          modals.showHideModalForHomeStorePage(this);
        } else if (sessionStorage.getItem('toPage') === '/home/store') {
          this.storeModalForStore(WelcomeReturningUnsub);
          modals.showHideModalForHomeStorePage(this);
        } else {
          this.storeModalForSettings(WelcomeReturningUnsub);
          modals.showHideModalForHomePage(this);
        }
      });
    },
  },
  computed: {
    ...mapState('profile', [
      'twoStepVerificationVerified',
      'twoStepVerificationWrongPin',
      'twoStepVerificationServerError',
    ]),
    ...mapGetters('i18n', [
      'getTranslations',
      'getTranslationByOperatorIfExists',
      'getTranslationByOperator',
    ]),
    ...mapState('common', [
      'operatorIndex',
      'multiOperatorInfo',
      'checkBoxEnabled',
      'userDetails',
    ]),
  },
};
</script>




// WEBPACK FOOTER //
// src/components/home/modals/ResubscribeViaPin.vue